/* eslint-disable @typescript-eslint/no-explicit-any */

import { combineItemArrays } from "./combine-item-arrays";
import { DocumentTableCell } from "./document-table-cell";

export const DocumentTableV2 = ({ data, parentKey }: any) => {
  const keys = Object.keys(data);

  const table = combineItemArrays(data, keys);
  return (
    <div className="overflow-auto">
      <div className="table w-full">
        <div className="table-row">
          {keys.map((key, index: number) => {
            return (
              <DocumentTableCell
                isHeader={true}
                key={index}
                data={key}
                keyValue={key}
              />
            );
          })}
        </div>
        {table.map((item: any, index: number) => {
          return (
            <div className="table-row" key={index}>
              {keys.map((key, rowIndex: number) => {
                const value = item[key].text;
                const currentKey = `${key}.${item[key].row_number - 1}`;
                return (
                  <DocumentTableCell
                    data={value}
                    key={rowIndex}
                    keyValue={currentKey}
                    parentKey={`${parentKey}.${currentKey}`}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};
